import React, { useEffect, useState } from "react";
import "./meal.css";
import { useParams, useNavigate } from "react-router-dom";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import axiosInstance, { axiosTokenInstance } from "../../axiosConfig/axios";
import { Button } from "react-bootstrap";
import { Minus, Plus, SaudiRiyal } from "lucide-react";
import ProductDetails from "./ProductDetails";
import Buy from "../../assets/images/Buy.svg";
import { Popup } from "../../components/poupup/Popup";
import Loading from "../../components/loading/loading";
import orderImg from "../../assets/images/order-done.svg";

const Meal = () => {
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(true);
  const [product, setProduct] = useState([]);
  const [Sizes, setSizes] = useState([]);
  const [productOptions, setProductOptions] = useState([]);
  const [options, setOptions] = useState([]);
  const [selectedSize, setSelectedSize] = useState(null);
  const [productPrice, setProductPrice] = useState(0);
  const [notes, setNotes] = useState("");
  const [isPopupOpen, setIsPopupOpen] = useState(false);
  let [count, setCount] = useState(1);
  const [selectedOptions, setSelectedOptions] = useState({});
  const [selectedModifiers, setSelectedModifiers] = useState([]);
  const [showMissingOptions, setShowMissingOptions] = useState(false);

  const params = useParams();

  const restaurantID = localStorage.getItem("restaurant");

  const getProductDetails = async () => {
    const { data } = await axiosInstance.get(
      `/connector/api/users/menu/${restaurantID}/singleItem/${params.id}`
    );

    setProduct(data?.data);
    setSizes(data.data.product_variations);
    setProductOptions(data.data.modifier_sets);

    setIsLoading(false);
  };

  useEffect(() => {
    getProductDetails();
  }, []);

  const handleCheckboxChange = (
    e,
    variationId,
    optionPrice,
    optionIndex,
    modifierSetId
  ) => {
    const isChecked = e.target.checked;

    setOptions((prevOptions) => {
      if (isChecked) {
        // إضافة option جديد
        return [
          ...prevOptions,
          { id: variationId, price: parseFloat(optionPrice) },
        ];
      } else {
        // إزالة option من اللي متخزنين
        return prevOptions.filter((opt) => opt.id !== variationId);
      }
    });

    setSelectedModifiers((prevSelectedModifiers) => {
      const existingModifier = prevSelectedModifiers.find(
        (mod) => mod.modifier_set_id === modifierSetId
      );

      if (isChecked) {
        if (existingModifier) {
          // لو موجود، نضيف ال variationId لو مش موجود بالفعل
          return prevSelectedModifiers.map((mod) => {
            if (mod.modifier_set_id === modifierSetId) {
              if (!mod.variations.includes(variationId)) {
                return {
                  ...mod,
                  variations: [...mod.variations, variationId],
                };
              }
            }
            return mod;
          });
        } else {
          // لو مش موجود، نضيفه
          return [
            ...prevSelectedModifiers,
            { modifier_set_id: modifierSetId, variations: [variationId] },
          ];
        }
      } else {
        // لو unchecked، نشيل variationId من المجموعة
        return prevSelectedModifiers
          .map((mod) => {
            if (mod.modifier_set_id === modifierSetId) {
              return {
                ...mod,
                variations: mod.variations.filter((id) => id !== variationId),
              };
            }
            return mod;
          })
          .filter((mod) => mod.variations.length > 0); // نشيل المجموعة لو بقت فاضية
      }
    });

    setSelectedOptions((prevSelected) => {
      const group = prevSelected[optionIndex] || [];

      let updatedGroup;

      if (isChecked) {
        updatedGroup = [...group, variationId];
      } else {
        updatedGroup = group.filter((id) => id !== variationId);
      }

      return {
        ...prevSelected,
        [optionIndex]: updatedGroup,
      };
    });

    // Handle price
    setProductPrice((prevPrice) =>
      isChecked
        ? parseFloat(prevPrice) + parseFloat(optionPrice)
        : parseFloat(prevPrice) - parseFloat(optionPrice)
    );
  };

  const handleSizeChange = (sizeId, sizePrice) => {
    setSelectedSize(sizeId);
    // Reset price to the base size price and reapply addons
    setProductPrice(() => {
      const addonsTotal = options.reduce((total, option) => {
        return total + parseFloat(option.price);
      }, 0);

      return parseFloat(sizePrice) + addonsTotal;
    });
  };

  const incrementCount = () => {
    setCount(count + 1);
  };

  const decrementCount = () => {
    if (count > 1) {
      setCount(count - 1);
    }
  };

  const requestProductBody = {
    product_id: product.id,
    variation_id: selectedSize,
    location_id: restaurantID,
    qty: count,
    notes: notes,
    modifiers: selectedModifiers,
  };

  const token = localStorage.getItem("token");

  const hasMissingRequiredOptions = () => {
    return productOptions.some((option, index) => {
      const isRequired = option.is_required === 1;
      const selectedCount = selectedOptions[index]?.length || 0;
      return isRequired && selectedCount === 0;
    });
  };

  const addToCart = async () => {
    try {
      const res = await axiosTokenInstance.post(
        "/connector/api/users/cart",
        requestProductBody
      );

      // console.log(res);

      if (res.data.status === 200) {
        setIsPopupOpen(true);
      }
    } catch (error) {
      if (error.response) {
        toast.error("Server error" + error.response.data.message, {
          position: toast.POSITION.BOTTOM_RIGHT,
          autoClose: 2000,
        });
        navigate("/login");
      } else if (error.request) {
        toast.error("No response from the server.", {
          position: toast.POSITION.BOTTOM_RIGHT,
          autoClose: 2000,
        });
      } else {
        toast.error("An error occurred: " + error.message, {
          position: toast.POSITION.BOTTOM_RIGHT,
          autoClose: 2000,
        });
      }
    }
  };

  const closePopup = () => {
    setIsPopupOpen(false);
  };

  return (
    <>
      {isLoading ? (
        <Loading />
      ) : (
        <>
          {isPopupOpen ? (
            <Popup
              imgPoupoup={orderImg}
              title="تمت الاضافة الى السلة"
              closePopup={closePopup}
              textBtn="اضافة المزيد"
              href="/menu"
              textBtn1="اذهب للسلة"
              href1="/cart"
            />
          ) : (
            <>
              <ProductDetails
                Product={product}
                Sizes={Sizes}
                selectedSize={selectedSize}
                productPrice={productPrice}
                productOptions={productOptions}
                handleCheckboxChange={handleCheckboxChange}
                notes={notes}
                setNotes={setNotes}
                handleSizeChange={handleSizeChange}
                selectedOptions={selectedOptions}
                showMissingOptions={showMissingOptions}
              />

              <div className="price-of-product-details-container">
                <div className="price-of-product-details">
                  <div className="total-product-price">
                    <div>
                      <p>السعر الاجمالى</p>
                      <p>
                        {productPrice * count} <SaudiRiyal size={14} />
                      </p>
                    </div>
                    <div className="product-group-btns">
                      <button className="plusBtn" onClick={incrementCount}>
                        <Plus size="16" />
                      </button>
                      <p>{count}</p>
                      <button className="minusBtn" onClick={decrementCount}>
                        <Minus size="16" />
                      </button>
                    </div>
                  </div>

                  <div
                    className="cart-footer"
                    onClick={(event) => {
                      event.preventDefault();

                      const hasMissing = hasMissingRequiredOptions();

                      setShowMissingOptions(true); 

                      if (hasMissing) {
                        toast.error("برجاء اختيار جميع الخيارات المطلوبة", {
                          position: toast.POSITION.BOTTOM_RIGHT,
                          autoClose: 2000,
                        });
                        return;
                      }

                      addToCart();
                    }}
                  >
                    <img className="Buy" src={Buy} alt="Buy" />{" "}
                    <Button>أضف الى السلة </Button>
                  </div>
                </div>
              </div>
            </>
          )}

          <ToastContainer />
        </>
      )}
    </>
  );
};

export default Meal;
